import { styled } from "@mui/material";

export const StyledContact = {
  Inner: styled("div")({
    display: "grid",
    gridTemplateColumns: "1fr 1.1fr",
    gap: "clamp(36px, 5vw, 70px)",
    alignItems: "start",
    "@media (max-width: 960px)": { gridTemplateColumns: "1fr" },
  }),

  Info: styled("div")({ maxWidth: 480 }),

  Methods: styled("div")({
    marginTop: 34,
    display: "flex",
    flexDirection: "column",
    gap: 14,
  }),

  Method: styled("a")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: 16,
    padding: "16px 20px",
    borderRadius: theme.custom.radius.md,
    background: "#fff",
    border: `1px solid ${theme.custom.colors.border}`,
    boxShadow: theme.custom.shadow.sm,
    transition: "transform 0.25s ease, border-color 0.25s ease",
    "&:hover": {
      transform: "translateY(-3px)",
      borderColor: "rgba(23,79,155,0.3)",
    },
    "& .method-icon": {
      width: 46,
      height: 46,
      flexShrink: 0,
      display: "grid",
      placeItems: "center",
      borderRadius: 13,
      color: "#fff",
      background: theme.custom.gradient.brand,
      "& svg": { fontSize: "1.25rem" },
    },
    "& small": {
      display: "block",
      fontSize: "0.78rem",
      color: theme.custom.colors.textSoft,
    },
    "& strong": {
      fontFamily: theme.custom.fonts.display,
      fontSize: "1.02rem",
      color: theme.palette.text.primary,
    },
  })),

  Socials: styled("div")({ marginTop: 26, display: "flex", gap: 12 }),

  Social: styled("a")(({ theme }) => ({
    width: 46,
    height: 46,
    display: "grid",
    placeItems: "center",
    borderRadius: 13,
    color: theme.palette.text.primary,
    background: "#fff",
    border: `1px solid ${theme.custom.colors.border}`,
    boxShadow: theme.custom.shadow.sm,
    transition: "transform 0.25s ease, color 0.25s ease, background 0.25s ease",
    "& svg": { fontSize: "1.25rem" },
    "&:hover": {
      transform: "translateY(-3px)",
      color: "#fff",
      background: theme.custom.gradient.brand,
    },
  })),

  FormWrap: styled("div")(({ theme }) => ({
    padding: "clamp(28px, 4vw, 42px)",
    borderRadius: theme.custom.radius.lg,
    background: "#fff",
    border: `1px solid ${theme.custom.colors.border}`,
    boxShadow: theme.custom.shadow.md,
  })),

  Form: styled("form")({
    display: "flex",
    flexDirection: "column",
    gap: 18,
  }),

  FieldRow: styled("div")({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 18,
    "@media (max-width: 480px)": { gridTemplateColumns: "1fr" },
  }),

  Field: styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: 7,
    "& label": {
      fontSize: "0.86rem",
      fontWeight: 600,
      color: theme.palette.text.primary,
      fontFamily: theme.custom.fonts.display,
    },
    "& input, & select, & textarea": {
      fontFamily: "inherit",
      fontSize: "0.96rem",
      color: theme.palette.text.primary,
      padding: "13px 15px",
      borderRadius: theme.custom.radius.sm,
      border: `1px solid ${theme.custom.colors.slate200}`,
      background: theme.palette.background.soft,
      transition: "border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease",
      width: "100%",
    },
    "& textarea": { resize: "vertical" },
    "& input:focus, & select:focus, & textarea:focus": {
      outline: "none",
      background: "#fff",
      borderColor: theme.custom.colors.indigo500,
      boxShadow: "0 0 0 4px rgba(23, 79, 155, 0.12)",
    },
  })),

  SubmitWrap: styled("div")({ marginTop: 6 }),

  Note: styled("p")(({ theme }) => ({
    fontSize: "0.8rem",
    color: theme.custom.colors.textSoft,
    textAlign: "center",
  })),

  Success: styled("div")(({ theme }) => ({
    textAlign: "center",
    padding: "30px 10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
    "& svg": { fontSize: "3.4rem", color: "#2E9BD9" },
    "& h3": {
      fontFamily: theme.custom.fonts.display,
      fontWeight: 700,
      fontSize: "1.5rem",
      marginTop: 8,
    },
    "& p": { color: theme.custom.colors.textSoft, maxWidth: "40ch" },
  })),
};
